import { Component } from '@angular/core';
import {FirebaseService} from './firebase.service';
import {Reise} from './types';
import {Observable} from 'rxjs';
import {Texte} from "../common/texte";
import {environment} from "../environments/environment";

@Component({
  selector: 'app-reisen',
  templateUrl: './reisen.component.html',
  styles: [
      '.mat-expansion-panel-header-description {flex-grow: 0.5}'
  ]
})
export class ReisenComponent {
  texte = new Texte(environment);
  items: Observable<Reise[]>;

  constructor(public service: FirebaseService) {
    this.items = service.getAlleReisen();
  }
}
